

const showFloatToPercentage = (num, decimals = 2) => {
  if (isNaN(num)) {
    return 0
  }
  return Math.round(num * Math.pow(10, decimals + 2)) / Math.pow(10, decimals)
}

export default showFloatToPercentage
